import { Skeleton } from '@dixa/lib-shared-habla';
import { MetricInstrumentData } from 'lib-analytics-ui';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo } from 'react';

import { useChannelDashboardChannelContext } from '../../../../channelDashboardChannel.context';
import { ChannelDashboardMetric } from '../../../metric/channelDashboardMetric';

type ChannelDashboardAssignmentTimeMetricProps = PropsWithClassName;

export const ChannelDashboardAssignmentTimeMetric = memo(
  function ChannelDashboardAssignmentTimeMetric({
    className,
  }: ChannelDashboardAssignmentTimeMetricProps): JSX.Element {
    const { metrics, isSkeleton } = useChannelDashboardChannelContext();

    return (
      <ChannelDashboardMetric
        className={className}
        title="Avg. assignment time"
        isSkeleton={isSkeleton}
        metricType="assignment_time"
      >
        {isSkeleton ? (
          <Skeleton height="24px" width="72px" />
        ) : (
          <MetricInstrumentData
            data={metrics?.average_assignment_time ?? null}
            format="duration"
          />
        )}
      </ChannelDashboardMetric>
    );
  },
);
